import React from "react";
import {useNavigate} from "react-router-dom";
import {EventId} from "../../interfaces/IEvent";
import EventsDataGrid from "./EventsDataGrid";
import {GridBreakpoint} from "../../interfaces/IGridSettings";
import SearchBar from "./SearchBar";
import {CustomContainer} from "../../components/Wrapper/CustomContainer";
import {Stack} from "@mui/material";

function EventsTable() {
    const navigate = useNavigate();
    const goToEvent = (eventId: EventId) => {
        navigate(`/events/${eventId}`);
    }

    return(
        <CustomContainer gridWidth={GridBreakpoint.xxl}>
            <Stack direction="column" spacing={1}>
                <SearchBar/>
                <EventsDataGrid goToEvent={goToEvent}/>
            </Stack>
        </CustomContainer>)
}

export default EventsTable;
